module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("3hXQ3"))).then(() => parcelRequire('hEqeo'));